//
//
//
//
//
//

export default {
  name: 'UserEmpty',
  data () {
    return {
      title: '潮州侨联'
    }
  },
  mounted () {
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', this.disableBrowserBack)
  },
  destroyed () {
    window.removeEventListener('popstate', this.disableBrowserBack, false)
  },
  methods: {
    disableBrowserBack () {
      history.pushState(null, null, document.URL)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/user/empty.vue